import { State } from "../Model/State";
export class PlayerService {
    constructor(storage, eventsChannelFactory, httpService, playersFactory, instanceId) {
        this.storage = storage;
        this.eventsChannelFactory = eventsChannelFactory;
        this.httpService = httpService;
        this.playersFactory = playersFactory;
        this.instanceId = instanceId;
        this.state = new State(null);
        this.playerEvents = undefined;
        this.isRegistered = new State(false);
        this.isJoin = new State(false);
        this.recoverState();
    }
    subscribe(sub) {
        return this.state.subscribe(sub);
    }
    getPlayer() {
        return this.state.value;
    }
    getEventsChannel() {
        if (!this.state.value) {
            throw new Error('No es posible obtener el canal de eventos del jugador sin registrarlo antes.');
        }
        return this.eventsChannelFactory.createEventsChannel(`player.${this.state.value.id}`);
    }
    async getRankingPosition() {
        if (!this.state.value) {
            throw new Error('No es posible obtener la posición en el ranking sin registrar antes al jugador.');
        }
        const response = await this.httpService.get(`ranking-position/${this.state.value.id}`);
        if (response.status === 404) {
            return null;
        }
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el ranking del jugador.');
        }
        return await response.json();
    }
    async register(name, pictureId, roomId, gameId) {
        let player = this.playersFactory.createPlayer(this.instanceId, false, name, pictureId, roomId);
        let response = await this.httpService.post('player', { player, game: gameId });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al registrar el jugador.');
        }
        //Descargamos los datos del jugador ya que el servidor puede
        //haber establecido la imagen del jugador
        response = await this.httpService.get(`player/${player.id}`);
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el jugador despues del registro.');
        }
        player = this.playersFactory.createPlayerFromDto(await response.json());
        this.state.set(player);
        this.isRegistered.set(true);
        this.saveState();
        this.bindPlayerEvents();
        return player;
    }
    async joinRoom(roomId, gameId) {
        if (!this.state.value) {
            throw new Error('No es posible unirse a una sala sin registrar antes al jugador.');
        }
        const response = await this.httpService.post('join', {
            playerId: this.state.value.id,
            roomId,
            gameId
        });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al unirse a la sala.');
        }
        this.isJoin.set(true);
    }
    async statusConnection(isConnected) {
        await this.httpService.get('player/' + this.getPlayer().id + '/' + isConnected + '/status-connect');
    }
    recoverState() {
        try {
            //Comprobamos la fecha de registro del usuario
            //Si han pasado más de 12 horas eliminamos el
            //registro del jugador.
            const saveTime = this.storage.getItem('player_save_time');
            if (saveTime) {
                const hoursAgo = Math.floor((Date.now() - new Date(saveTime).getTime()) / (1000 * 60 * 60));
                if (hoursAgo > 12) {
                    //Borramos el registro del jugador
                    this.storage.removeItem('player');
                    this.storage.removeItem('player_save_time');
                    return;
                }
            }
            const json = this.storage.getItem('player');
            if (!json) {
                return;
            }
            const { id, identityOverride, name, pictureId, roomId } = JSON.parse(json);
            const player = this.playersFactory.createPlayer(id, identityOverride, name, pictureId, roomId);
            this.state.set(player);
            this.isRegistered.set(true);
            this.bindPlayerEvents();
            this.recoverStateFromServer();
        }
        catch (error) {
            console.error(error);
        }
    }
    saveState() {
        if (!this.isRegistered.value) {
            this.storage.removeItem('player');
            return;
        }
        this.storage.setItem('player', JSON.stringify(this.getPlayer()));
        this.storage.setItem('player_save_time', new Date().toISOString());
    }
    async recoverStateFromServer() {
        const response = await this.httpService.get(`player/${this.state.value.id}`);
        if (!response.ok) {
            this.clear();
            console.warn('Ha ocurrido un error al recuperar el estado del jugador.');
            return;
        }
        this.state.set(this.playersFactory.createPlayerFromDto(await response.json()));
    }
    clear() {
        var _a;
        if (!this.isRegistered.value) {
            return;
        }
        this.isRegistered.set(false);
        this.state.set(null);
        (_a = this.playerEvents) === null || _a === void 0 ? void 0 : _a.destroy();
        this.playerEvents = undefined;
    }
    bindPlayerEvents() {
        if (this.playerEvents) {
            return;
        }
        this.playerEvents = this.eventsChannelFactory.createEventsChannel(`player.${this.state.value.id}`);
        this.playerEvents.on('identity_override', ({ data }) => {
            if (!this.isRegistered.value) {
                return;
            }
            this.state.value.identityOverride.set(true);
            this.state.value.name.set(data.player.name);
            this.state.value.pictureId.set(data.player.pictureId);
        });
    }
    async getAvatar() {
        let response = await this.httpService.get('playerAvatar');
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al obtener el avatar del jugador.');
        }
        return await response.json();
    }
}
